// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "a[data-v-226760b3]{text-decoration:none}.back-link[data-v-226760b3]{margin-left:90px}", ""]);
// Exports
module.exports = exports;
